import React, { useState, useEffect } from 'react';
import MicRecorder from 'mic-recorder-to-mp3';
import io from 'socket.io-client';
import axios from 'axios';
import { FaMicrophone, FaStop } from 'react-icons/fa';
import { alert_error, alert_success } from "../AppContext.js";
import { useParams } from 'react-router-dom';
import { RingLoader } from "react-spinners";
import { TiTick } from 'react-icons/ti';
import { Cookies } from '../index.js';
import Select from 'react-select';

const Mp3Recorder = new MicRecorder({ bitRate: 128 });

const Recordaudio = () => {
  const [options, setOptions] = useState([
    { label: 'Phát  tiếng luôn ra loa', value: 'voice' },
    { label: 'Ghi âm vô file', value: 'save' },
  ]);
  const [isRecording, setIsRecording] = useState(false);
  const [blobURL, setBlobURL] = useState('');
  const [isBlocked, setIsBlocked] = useState(false);
  const [nutxuly, setnutxuly] = useState(0);
  const [nutorder, setnutorder] = useState("Ấn đây để phát");
  const [blobdata, setblobdata] = useState(null);
  const [dalaythongtin, setdalaythongtin] = useState(false);
  const [thongtincum, setthongtincum] = useState(false);
  const [ToChucIds, setToChucIds] = useState(false);
  const [socumphat, setsocumphat] = useState(0);
  const { slug_2 } = useParams();
  const [ThietBiId, setThietBiId] = useState([]);
  const [startTime, setstartTime] = useState(false);
  const [audioDuration, setaudioDuration] = useState(false);
  const [dungghi, setdungghi] = useState(false);
  const [them20giay, setthem20giay] = useState(false);

  // console.log(slug_2);
  useEffect(() => {
    laythongtin();
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then((stream) => {
        console.log('Permission Granted');
        setIsBlocked(false);
        laythongtin2();
        // Use the stream object for further processing, e.g., audio recording
      })
      .catch((error) => {
        console.log('Permission Denied: ', error);
        setIsBlocked(true);
      });

  }, []);
  function handleClick(itemId) {
    // Kiểm tra xem phần tử đã được chọn hay chưa
    const isSelected = ThietBiId.includes(itemId);

    // Nếu đã chọn, loại bỏ khỏi danh sách
    // Nếu chưa chọn, thêm vào danh sách
    const shdfbjhsdfbj = isSelected ? ThietBiId.filter(id => id !== itemId) : [...ThietBiId, itemId];
    setThietBiId(shdfbjhsdfbj);
    setsocumphat(shdfbjhsdfbj.length);
    console.log(socumphat);
  };
  function laythongtin2() {
    const myCookieValue = Cookies.get('apikey');
    console.log(myCookieValue);
    axios.get('https://hust.media/truyenthanh/sql/them20giay.php', {
      params: {
        apikey: myCookieValue
      }
    })
      .then(response => {
        if (response.data != '') {
          console.log(response.data); // Dữ liệu từ API
          setthem20giay(response.data);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };
  function laythongtin() {
    axios.get('https://hust.media/truyenthanh/usercum.php', {
      params: {
        username: slug_2
      }
    })
      .then(response => {
        console.log(response.data); // Dữ liệu từ API
        setdalaythongtin(true);
        setthongtincum(response.data.Data);
        setToChucIds(parseInt(response.data.ToChucIds));
        console.log(ToChucIds); // 7134

        // Xử lý dữ liệu ở đây
      })
      .catch(error => {
        alert_error(error);
      });
  };
  // const handleClick = (itemId) => {
  //   if ( itemId == ThietBiId )
  //   {
  //     setThietBiId();
  //   }
  //   else
  //   {
  //     setThietBiId(itemId);
  //   }
  // };
  const startRecording = () => {
    if (isBlocked) {
      alert_error('Mic bị lỗi');
    } else if (ThietBiId && socumphat != '0') {
      // socket.on('startRecording', () => {
      //   // Xử lý logic khi bắt đầu ghi âm
      //   console.log('Đã bắt đầu ghi âm');
      // });
      console.log(ThietBiId);
      Mp3Recorder.start()
        .then(() => {
          setstartTime(Date.now());
          setIsRecording(true);
          startSendingAudio();
        })
        .catch((e) => console.error(e));
    }
    else {
      setIsRecordingok(false);
      alert_error('chưa chọn cụm phát');
    }
  };
  function stopRecording() {
    setdungghi(true);
    setTimeout(() => {
      stopRecordingok();
    }, 1000);
  }

  const stopRecordingok = () => {
    // socket.disconnect();
    setdungghi(false);
    Mp3Recorder.stop()
      .getMp3()
      .then(([buffer, blob]) => {
        const blobURL = URL.createObjectURL(blob);
        setBlobURL(blobURL);
        setIsRecording(false);
        sendAudioData(blob);
        setblobdata(blob);
        const endTime = Date.now();
        console.log(endTime);
        setaudioDuration(Math.floor((endTime - startTime) / 1000 + 1)); // Tính số giây đã ghi âm
        console.log("Số giây đã ghi âm: ", audioDuration);
      })
      .catch((e) => console.log(e));

  };

  const sendAudioData = (audioBlob) => {
    const formData = new FormData();
    formData.append('file', audioBlob); // blob là biến chứa dữ liệu audioBlob

    // axios.post('http://103.200.20.147:3003', formData)
    //   .then((response) => {
    //     console.log('File uploaded successfully');
    //   })
    //   .catch((error) => {
    //     console.error('Error uploading file:', error);
    //   });
  };
  function handleSubmit(event) {

    // const apikey = Cookies.get("apikey");
    event.preventDefault();

    setnutxuly(1);
    setnutorder("Please wait a moment 😊");
    if (!blobdata || !audioDuration || !ToChucIds) {
      alert_error("Đã xảy ra lỗi vui lòng liên hệ đội ngũ hỗ trợ");
      setnutxuly(0);
      setnutorder("Đặt lại");
      return;
    }
    const formData = new FormData();
    formData.append('file', blobdata); // blob là biến chứa dữ liệu audioBlob
    if (them20giay) {
      const urlapiok = 'https://test.tecom.pro:3003' + '?username=' + slug_2 + '&audioDuration=' + audioDuration + '&ThietBiId=' + ThietBiId
        + '&service=' + service + '&ToChucIds=' + ToChucIds + '&them20giay=' + them20giay + '&socumphat=' + socumphat;
      axios.post(urlapiok, formData)
        .then((response) => {
          setnutxuly(0);
          alert_success('Thành công');
          setnutorder("Ấn đây để phát");
          setBlobURL(null);
          console.log(response);
        })
        .catch((error) => {
          setnutxuly(0);
          setnutorder("Đặt lại");
          alert_error(error);
        });
    }
    else {
      const urlapiok = 'https://test.tecom.pro:3003' + '?username=' + slug_2 + '&audioDuration=' + audioDuration + '&ThietBiId=' + ThietBiId
        + '&service=' + service + '&ToChucIds=' + ToChucIds + '&socumphat=' + socumphat;
      axios.post(urlapiok, formData)
        .then((response) => {
          setnutxuly(0);
          alert_success('Thành công');
          setnutorder("Ấn đây để phát");
          setBlobURL(null);
          console.log(response);
        })
        .catch((error) => {
          setnutxuly(0);
          setnutorder("Đặt lại");
          alert_error(error);
        });
    }

  }
  const startSendingAudio = () => {

    Mp3Recorder
      .getMp3()
      .then(([buffer, blob]) => {
        // sendAudioData(blob);
      })
      .catch((e) => console.log(e));

  };
  const [isRecordingok, setIsRecordingok] = useState(false);

  const handleRecording = () => {
    console.log(isRecordingok);
    setIsRecordingok(!isRecordingok);
    if (isRecordingok == true) {
      stopRecording();
    }
    else if (isRecordingok == false) {
      startRecording();
    }

  };
  const [isOpen, setIsOpen] = useState(true);
  const [service, setservice] = useState(null);
  const handleFocus = () => {
    setIsOpen(true);
    console.log(123);
  };
  const handleBlur = () => {
    setIsOpen(false);
  };
  const handleMenuOpen = () => {
    setIsOpen(true);
  };
  const initialSelectedOption = null;

  const [selectedOption, setSelectedOption] = useState(null);

  const handleChange = (selectedOption) => {
    setIsOpen(false);
    setservice(selectedOption.value);
    setSelectedOption(selectedOption);
    if (selectedOption.value == 'save') {
      setnutorder("Ấn đây để đẩy file");
    }
    else if (selectedOption.value == 'voice') {
      setnutorder("Ấn đây để phát");
    }
  };

  return (
    <>
      {
        dungghi ? (<div className="flex justify-center items-center">
          <RingLoader size={80} color="#0000ff" loading={dalaythongtin} />{" "}
        </div>
        ) : !dalaythongtin && !thongtincum ? (<div className="flex justify-center items-center">
          <RingLoader size={80} color="#0000ff" loading={dalaythongtin} />{" "}
        </div>
        ) : (
          <div className="max-w-2xl px-1 py-4   mx-auto rounded-lg shadow-xl ">
            <div className="container-fluid mt-0 flex  flex-col  items-center justify-center">
              <label
                htmlFor="countries2"
                className="text-center text-xs  mb-0  font-medium"
              >
                Chọn dịch vụ
              </label>
              <Select
                className="w-full max-w-md mb-4"
                classNamePrefix="Chọn 1 lựa chọn"
                onFocus={handleFocus}
                options={options}
                menuIsOpen={isOpen}
                onBlur={handleBlur}
                onMenuOpen={handleMenuOpen}
                onChange={handleChange} // Use selectedOption.value to get the selected value
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                defaultValue={selectedOption} // Sử dụng defaultValue thay vì value

                isSearchable={false}
              />


              <div className="relative mt-1 inline-block">
                <button
                  className={`bg-green-500 hover:bg-green-600 text-white rounded-full w-28 h-28 flex items-center justify-center focus:outline-none ${isRecording ? 'ring-2 ring-green-600' : ''
                    }`}
                  onClick={handleRecording}
                >
                  {isRecording ? (
                    <FaStop className="text-2xl" />
                  ) : (
                    <FaMicrophone className="text-2xl" />
                  )}
                  {isRecording && (
                    <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
                      <div className="absolute w-28 h-28 bg-green-500 opacity-50 rounded-full animate-pulse"></div>
                      <div className="absolute w-32 h-32 bg-green-500 opacity-20 rounded-full animate-pulse"></div>
                      <div className="absolute w-36 h-36 bg-green-500 opacity-10 rounded-full animate-pulse"></div>
                    </div>
                  )}
                </button>


              </div>{blobURL && !isRecordingok && (
                <>
                  <audio src={blobURL} className="mt-2" controls="controls" />
                  <button disabled={nutxuly == 1}
                    onClick={handleSubmit}
                    className="my-3 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-0 w-full dark:bg-slate-800 dark:text-white"
                  >
                    <div className="flex items-center justify-between flex-1">
                      {nutxuly == 1 && (
                        <div className="spinner-border" role="status"></div>
                      )}

                      <span className="text-lg font-medium text-white">
                        {nutorder}{" "}
                      </span>
                      <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                    </div>
                  </button> </>
              )}

            </div>
            <div className="grid mt-3 grid-cols-2 gap-4">
              {thongtincum.map((item) => (
                <div
                  key={item.Id}
                  className={`bg-gray-200 p-4 rounded-lg cursor-pointer ${ThietBiId.includes(item.Id) ? 'bg-green-200' : ''
                    }`}
                  onClick={() => handleClick(item.Id)}
                >
                  <div className="flex items-center justify-center mb-2">
                    {ThietBiId.includes(item.Id) && (
                      <TiTick className="w-10 h-10 text-green-500" />
                    )}
                  </div>
                  <p className="text-center">{item.TenThietBi}</p>
                </div>
              ))}
            </div>
          </div>
        )}
    </>
  );
};

export default Recordaudio;
